import React, { useEffect } from "react";
import { useSelector } from "react-redux";

export default function useGetUserData() {
  const user = useSelector((state: any) => state.user);
  return { user: user?.data?.user, isLoggedIn: !!user?.data?.token };
}
